export class OtpVerificationAttemptsExceededException extends Error {
  constructor(message) {
    super(message);
  }
}